/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommentIncidentEventDto } from '../models/CommentIncidentEventDto';
import type { CreateCommentDto } from '../models/CreateCommentDto';
import type { CreateIncidentDto } from '../models/CreateIncidentDto';
import type { GetCollaborationToolItemDto } from '../models/GetCollaborationToolItemDto';
import type { GetIncidentDetailsResponseDto } from '../models/GetIncidentDetailsResponseDto';
import type { ImpactedAssetsSearchDto } from '../models/ImpactedAssetsSearchDto';
import type { IncidentCatalogDto } from '../models/IncidentCatalogDto';
import type { IncidentDetailDto } from '../models/IncidentDetailDto';
import type { IncidentMutingDto } from '../models/IncidentMutingDto';
import type { IncidentNotificationDestinationsResponseDto } from '../models/IncidentNotificationDestinationsResponseDto';
import type { IncidentScope } from '../models/IncidentScope';
import type { IncidentSearchCriteria } from '../models/IncidentSearchCriteria';
import type { IncidentSearchCriteriaV2 } from '../models/IncidentSearchCriteriaV2';
import type { IncidentSearchDto } from '../models/IncidentSearchDto';
import type { IssueDetailsDto } from '../models/IssueDetailsDto';
import type { LinkedIncidentMonitorsDto } from '../models/LinkedIncidentMonitorsDto';
import type { LinkIncidentMonitorsDto } from '../models/LinkIncidentMonitorsDto';
import type { MergeIncidentsDto } from '../models/MergeIncidentsDto';
import type { PatchIncidentDto } from '../models/PatchIncidentDto';
import type { PostCollaborationToolItemDto } from '../models/PostCollaborationToolItemDto';
import type { SearchCollectionIncidentEventDto } from '../models/SearchCollectionIncidentEventDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IncidentService {

    /**
     * Get assets impacted by incident
     * @returns ImpactedAssetsSearchDto Successfully fetch impacted assets
     * @throws ApiError
     */
    public static getDownstreamImpactedAssets({
        issueNo,
        page,
        itemsPerPage = 25,
        sort,
    }: {
        /**
         * Retrieve impacted assets related to a given incident
         */
        issueNo?: number,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
        /**
         * The resource fields on which to apply the sort, format : property,ASC|DESC
         */
        sort?: Array<string>,
    }): CancelablePromise<ImpactedAssetsSearchDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/incidents/downstream-impacted-assets',
            query: {
                'issueNo': issueNo,
                'page': page,
                'itemsPerPage': itemsPerPage,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get incidents
     * @returns IncidentSearchDto List of Incident
     * @throws ApiError
     */
    public static getAllIncident({
        requestBody,
    }: {
        requestBody: IncidentSearchCriteria,
    }): CancelablePromise<IncidentSearchDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/incidents/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get single incident by issue number
     * @returns IssueDetailsDto Successfully fetch Incident
     * @throws ApiError
     */
    public static getIncidentByIssueNumber({
        issueNo,
    }: {
        issueNo: number,
    }): CancelablePromise<IssueDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/incidents/{issueNo}',
            path: {
                'issueNo': issueNo,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get aggregated incident events
     * @returns SearchCollectionIncidentEventDto List of Incident Events
     * @throws ApiError
     */
    public static getAggregatedIncidentEventsByIssueNumber({
        issueNo,
    }: {
        issueNo: number,
    }): CancelablePromise<SearchCollectionIncidentEventDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/incidents/{issueNo}/aggregated-events',
            path: {
                'issueNo': issueNo,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get single incident scope by issue number
     * @returns IncidentScope Successfully fetch Incident scope
     * @throws ApiError
     */
    public static getIncidentScopeByIssueNumber({
        issueNo,
    }: {
        issueNo: number,
    }): CancelablePromise<IncidentScope> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/incidents/{issueNo}/scope',
            path: {
                'issueNo': issueNo,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create an incident
     * @returns IncidentDetailDto Successfully create Incident
     * @throws ApiError
     */
    public static createIncident({
        requestBody,
    }: {
        requestBody: CreateIncidentDto,
    }): CancelablePromise<IncidentDetailDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Merge existing incidents
     * @returns IncidentDetailDto Successfully merged incidents
     * @throws ApiError
     */
    public static mergeIncidents({
        requestBody,
    }: {
        requestBody: MergeIncidentsDto,
    }): CancelablePromise<IncidentDetailDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/_merge-incidents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get incidents v2
     * @returns IncidentCatalogDto List of Incident v2
     * @throws ApiError
     */
    public static getAllIncidentsV2({
        requestBody,
    }: {
        requestBody: IncidentSearchCriteriaV2,
    }): CancelablePromise<IncidentCatalogDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/catalog',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Patch an incident
     * @returns IncidentDetailDto Successfully patch Incident
     * @throws ApiError
     */
    public static patchIncident({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: PatchIncidentDto,
    }): CancelablePromise<IncidentDetailDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/ui/v2/incidents/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Comment on an incident
     * @returns CommentIncidentEventDto Successfully add comment
     * @throws ApiError
     */
    public static addComment({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: CreateCommentDto,
    }): CancelablePromise<CommentIncidentEventDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/{id}/_comment',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Link monitors to an existing incident
     * @returns LinkedIncidentMonitorsDto Successfully link monitors to Incident
     * @throws ApiError
     */
    public static linkRulesToIncident({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: LinkIncidentMonitorsDto,
    }): CancelablePromise<LinkedIncidentMonitorsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/{id}/_link-monitors',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a Collaboration Tool Item linked to an Incident
     * @returns GetCollaborationToolItemDto Successfully created and linked Collaboration Tool Item
     * @throws ApiError
     */
    public static postCollaborationToolItem({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: PostCollaborationToolItemDto,
    }): CancelablePromise<GetCollaborationToolItemDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/{id}/collaboration-tool-items',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update the muted status of an incident
     * @returns void
     * @throws ApiError
     */
    public static muteIncident({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: IncidentMutingDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v2/incidents/{id}/mute',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Effective notification destinations for an incident
     * @returns IncidentNotificationDestinationsResponseDto Successfully resolved incident notification destinations
     * @throws ApiError
     */
    public static getIncidentNotificationDestinations({
        id,
    }: {
        id: string,
    }): CancelablePromise<IncidentNotificationDestinationsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v2/incidents/{id}/notification-destinations',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get single incident details by issue number
     * @returns GetIncidentDetailsResponseDto Successfully fetch incident details
     * @throws ApiError
     */
    public static getIncidentDetailsByIssueNumber({
        issueNo,
    }: {
        issueNo: number,
    }): CancelablePromise<GetIncidentDetailsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v2/incidents/{issueNo}/details',
            path: {
                'issueNo': issueNo,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
